import React from 'react';
import { Checkbox } from 'react-icheck';
class ICheck extends React.Component {

  constructor(...args) {
    super(...args)
    this.state = {}
  }

  onChange() {
    let {formData} = this.props
    if (formData)
        formData = false
    else
        formData = true     
    this.props.onChange(formData)
  }

  render() {
    let {schema,formData} = this.props
    return (
        <Checkbox
            onChange={this.onChange.bind(this)}
            checked={formData==='false'?false:formData==='true'?true:formData}
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            label={' '+schema.title}
        >
        </Checkbox>
    )
  }
}

export default ICheck;



// WEBPACK FOOTER //
// ./src/component/element/ICheck.js